import { j as l } from "../../../jsx-runtime-CQ7OqOhn.js";
import { faMinus as c, faCheck as m } from "@fortawesome/pro-solid-svg-icons";
import f from "../Icon/Icon.js";
import u from "../../../tailwindConfig/bclTwMerge.js";
const C = ({
  disabled: t,
  checked: s,
  className: e = "",
  ...o
}) => {
  const r = "size-5 text-neutral-default", n = "text-disabled", a = s === "indeterminate" ? c : m, i = u(
    r,
    t && n,
    e
  );
  return s === !1 ? null : /* @__PURE__ */ l.jsx(f, { className: i, icon: a, ...o });
};
export {
  C as CheckboxIcon
};
